import {DeliousApiClientProd} from "@/_global/api_clients/DeliousApiClientProd";
import {DeliousApiClientLocal} from "@/_global/api_clients/DeliousApiClientLocal";

interface IDeliousApiClient {
    getUser: () => Promise<any>;
    getItemSearchList: (storeId: number, generationId: number) => Promise<any>;
    getStores: () => Promise<any>;
    getGenerations: () => Promise<any>;
    getItemDetailList: (storeId: number, periodId: number) => Promise<any>;
    getPluClassList: (storeId: number, level: string) => Promise<any>;
}

export let DeliousApiClient: IDeliousApiClient = DeliousApiClientProd;

export function deliousApiClientToLocalMode() {
    DeliousApiClient = DeliousApiClientLocal;
}
